import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Outlet, Link, useLocation } from 'react-router-dom';
import NavigationSidebar from '../Navigation/NavigationSidebar';
import MobileDrawerToggle from '../Navigation/MobileDrawer';
import { useNavigation } from '../Navigation/NavigationContext';
import '../../design-system/admin-screens.css';

const DashboardLayout: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const { sidebarOpen, toggleSidebar } = useNavigation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const pageNames: Record<string, string> = {
    '/dashboard': 'ダッシュボード',
    '/appointments/list': '診療予約データ一覧',
    '/appointments/out-of-hours': '指定時間外予約一覧',
    '/appointments/upload': '診療予約CSVアップロード',
    '/settings/account': 'アカウント管理',
    '/doctors/list': '医師管理',
    '/doctors/shift-rules': '医師シフトルール',
    '/doctors/monthly-shift-slots': '月次シフト枠設定',
    '/doctors/shifts/manager': '月次シフト管理',
    '/doctors/shifts/monthly': '月次医師シフト管理',
    '/doctors/reservation-slots': '解放枠管理',
    '/doctors/shifts': '医師シフト管理',
    '/doctors/shift-upload': '医師シフトCSVアップロード',
    '/content/notices': 'お知らせ管理',
    '/content/banners': 'バナー管理',
    '/content/withdrawal-questionnaires': '解約アンケート管理',
  };
  const checkKitViews: Record<string, string> = {
    orders: '注文管理',
    'flora-results': 'フローラ結果',
    'stds-results': '性病検査結果',
    enquetes: '生活習慣アンケート',
  };
  const section = location.pathname.startsWith('/appointments/') ? '予約管理' : location.pathname.startsWith('/doctors/') ? '医師管理' : location.pathname.startsWith('/content/') ? 'マイページ管理' : location.pathname === '/check-kits' ? '検査キット管理' : location.pathname.startsWith('/settings/') ? '設定' : '';
  const sectionPath = section === '予約管理' ? '/appointments/list' : section === '医師管理' ? '/doctors/shifts' : section === 'マイページ管理' ? '/content/notices' : section === '検査キット管理' ? '/check-kits?view=orders' : section === '設定' ? '/settings/account' : '/dashboard';
  const pageName = location.pathname === '/check-kits'
    ? checkKitViews[new URLSearchParams(location.search).get('view') || 'orders'] || '注文管理'
    : pageNames[location.pathname] || '管理画面';

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* サイドバー */}
      <NavigationSidebar open={sidebarOpen} onToggle={toggleSidebar} />

      {/* モバイル用メニューボタン */}
      <MobileDrawerToggle />

      {/* メインコンテンツ */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          p: 0,
          width: '100%',
          transition: theme.transitions.create(['padding'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh',
        }}
      >
        <Box component="header" sx={{ display: 'flex', alignItems: 'center', minHeight: 56, px: isMobile ? 2 : 4, pl: isMobile ? 8 : 4, borderBottom: '1px solid #dedbd7', bgcolor: '#fff', overflow: 'hidden' }}>
          <Box component="nav" aria-label="パンくず" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, color: '#77716d', fontSize: isMobile ? 10 : 11, whiteSpace: 'nowrap', '& a': { color: 'inherit', textDecoration: 'none' }, '& a:hover': { color: '#9f545c', textDecoration: 'underline' }, '& strong': { overflow: 'hidden', textOverflow: 'ellipsis', color: '#272522' } }}>
            <Link to="/dashboard">管理画面</Link>{section && <><span>/</span><Link to={sectionPath}>{section}</Link></>}<span>/</span><strong aria-current="page">{pageName}</strong>
          </Box>
        </Box>
        <Box className="admin-workspace" sx={{ p: isMobile ? 2 : 3, minWidth: 0 }}>
          <div className="admin-page-transition" key={location.pathname}><Outlet /></div>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
